module.exports = __webpack_public_path__ + "media/img/flags/France-e81efecf1a1b1d3a17d00a904c5cc3c9.png";